import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { HelperText } from '../../../helper-text/HelperText.mjs';
import { useFormFieldContext } from '../../context.mjs';

const FormFieldHelperText = forwardRef(
  ({ disabled: disabledFromProps, state: stateFromProps, ...props }, forwardedRef) => {
    const { disabled: disabledFromContext, state: stateFromContext } = useFormFieldContext("FormField.HelperText");
    return /* @__PURE__ */ jsx(
      HelperText,
      {
        "data-scope": "form-field",
        "data-part": "helper-text",
        disabled: disabledFromProps ?? disabledFromContext,
        state: stateFromProps ?? stateFromContext,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
FormFieldHelperText.displayName = "FormField.HelperText";

export { FormFieldHelperText };
//# sourceMappingURL=HelperText.mjs.map
